import React from 'react'
import classNames from 'classnames'
import './styles.scss'
import arrowForward from '../../../../assets/arrow_forward.svg'

function CarouselController({ onClick, withNavigation, count, index, className = '' }) {
  return (
    <div
      className={classNames({
        'carousel-controller': true,
        [className]: true,
      })}
    >
      <button
        type="button"
        onClick={() => onClick('prev')}
      >
        <img
          src={arrowForward}
          alt="Arrow backward"
          className="rotate-180"
        />
      </button>

      {withNavigation && (
        <div className="carousel-controller-nav">
          <div className="carousel-controller-counter">
            {index}/{count}
          </div>
          <div className="dots-container">
            {[...Array(count)].map((item, idx) => (
              <div
                key={idx}
                className={classNames({
                  dot: true,
                  'dot--active': idx + 1 === index,
                })}
                onClick={() => onClick(idx)}
              />
            ))}
          </div>
        </div>
      )}

      <button
        type="button"
        onClick={() => onClick('next')}
      >
        <img
          src={arrowForward}
          alt="Arrow forward"
        />
      </button>
    </div>
  )
}

export default CarouselController
